<template>
  <div
    style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 51px;
          margin-top: 30px
        "
  >

    <div id="chartLine" class="line-wrap" style="width: 100%;height: 600px;" />
  </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  components: {},
  props: {},
  data() {
    return {
      chartLine: null
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this.drawLineChart()
    })
  },
  methods: {
    drawLineChart() {
      this.chartLine = echarts.init(document.getElementById('chartLine'))// 基于准备好的dom，初始化echarts实例
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisTick: {
              show: false
            },
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            name: '（人）'
          }
        ],
        series: [
          {
            name: '邮件营销',
            type: 'line',
            stack: '总量',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '联盟广告',
            type: 'line',
            stack: '总量',
            data: [220, 182, 191, 234, 290, 330, 310]
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表
      this.chartLine.setOption(option)
    }
  }
}
</script>
<style scoped lang='less'>

</style>
